<template>
  <div class="flex flex-col justify-between font-sans-serif">
    <div class="bg-beige-academy-300 text-white text-center py-6 mb-4">
      <h1 class="w-full px-4
      font-bold tracking-widest uppercase text-md mb-2">
        {{ question }}
      </h1>
    </div>
    <div class="flex flex-row justify-between my-2 text-sm w-1/2 mx-auto mb-10">
        <button
          @click="$emit('close')"
          class="mx-2 py-3 rounded border hover:bg-background-academy
          border-background-academy w-1/2 hover:text-white
         text-background-academy font-bold
          cursor-pointer md:w-full">
            {{ $t('cards.cancel') }}
        </button>
        <button
          @click="$emit('delete')" :class="isLoading ? 'loader' : ''"
          class="mx-2 py-3 rounded border w-1/2 hover:bg-background-academy
          border-background-academy hover:text-white
          text-background-academy font-bold
          cursor-pointer md:w-full">
            {{ $t('cards.delete') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['question', 'isLoading'],

};
</script>
